<template>
  <div>
    <instructor-edit-form page="setting" />
  </div>
</template>

<script>
import InstructorEditForm from "./InstructorForm/index.vue";
export default {
	name: "Instructor",
	components: { InstructorEditForm },
};
</script>

<style scoped>
</style>
